export const getElementDetailsBarVariant = (status: {
  hasStarted: boolean;
  hasLive: boolean;
  allFinished: boolean;
}) => {
  if (status.hasLive) return "live";
  if (status.allFinished) return "finished";
  return "default";
};
